// extracted by mini-css-extract-plugin
export default {"searchContainer":"tableSearchInput_searchContainer__TB1UT"};